const GENDER_OPTIONS = [
  { label: '男', value: 'M' },
  { label: '女', value: 'F' }
];

export default GENDER_OPTIONS;
